export default "__VITE_ASSET__CevACfhH__"